import { Route, Routes } from "react-router-dom";

import { Routes as AdminRoutes } from "ui/modules/navigation";

import { TenantsSearchPage } from "../pages/TenantsSearchPage";
import { TenantDetailPage } from "../pages/TenantDetailPage";
import TenantActivitiesPage from "../pages/TenantDetailPage/components/TenantActivitiesPage/TenantActivitiesPage";
import TenantSubscriptionPage from "../pages/TenantDetailPage/components/TenantSubscriptionPage/TenantSubscriptionPage";
import TenantUsersPage from "../pages/TenantDetailPage/components/TenantUsersPage/TenantUsersPage";

import { TenantRouterCmp } from "./types";

const TenantRouter: TenantRouterCmp = () => (
  <Routes>
    <Route path={TenantsSearchPage.route} element={<TenantsSearchPage />} />
    <Route path={TenantDetailPage.route} element={<TenantDetailPage />} />
    <Route path={TenantSubscriptionPage.route} element={<TenantSubscriptionPage />} />
    <Route path={TenantUsersPage.route} element={<TenantUsersPage />} />
    <Route path={TenantActivitiesPage.route} element={<TenantActivitiesPage />} />
  </Routes>
);

TenantRouter.route = AdminRoutes.ModuleRouter;

export default TenantRouter;
